
import { useSearchParams } from "react-router-dom";
import { useJournalEntries } from "./journal/useJournalEntries";
import { EntriesLoader } from "./journal/EntriesLoader";
import { EntriesControls } from "./journal/EntriesControls";
import { EntriesGridView } from "./journal/EntriesGridView";
import { EntriesListView } from "./journal/EntriesListView";
import { EmptyEntriesState } from "./journal/EmptyEntriesState";

export const JournalEntries = () => {
  const [_, setSearchParams] = useSearchParams();
  const { 
    filteredEntries, 
    loading, 
    searchTerm, 
    setSearchTerm, 
    sortOption, 
    setSortOption,
    viewMode,
    setViewMode,
    handleLike,
    handleDelete
  } = useJournalEntries();

  const handleAddFirstEntry = () => {
    setSearchParams({ tab: 'new' });
  };

  if (loading) {
    return <EntriesLoader />;
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h2 className="text-2xl font-bold text-primary">Your Cooking Journey</h2>
        
        <EntriesControls 
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          sortOption={sortOption}
          onSortChange={setSortOption}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
        />
      </div>
      
      {filteredEntries.length === 0 ? (
        <EmptyEntriesState 
          searchTerm={searchTerm}
          onClearSearch={() => setSearchTerm('')}
          onAddFirstEntry={handleAddFirstEntry}
        />
      ) : (
        viewMode === 'grid' ? 
          <EntriesGridView 
            entries={filteredEntries} 
            onLike={handleLike} 
            onDelete={handleDelete} 
          /> : 
          <EntriesListView 
            entries={filteredEntries} 
            onLike={handleLike} 
            onDelete={handleDelete} 
          />
      )}
    </div>
  );
};
